import { routes as pdiRes4256 } from './pdi-res4256';
import { routes as pdiEstrutura } from './pdi-estrutura';
import { routes as pdiAnamnese } from './pdi-anamnese';
import { routes as pdiPendente } from './pdi-pendente';
import { routes as informacoesComplementares } from './informacoes-complementares';

// Módulo Educação Inclusiva — Plano de Desenvolvimento Individual (PDI).
// Agrega as entidades do módulo sob o nó /educacaoinclusiva (filho de /home).
export default [
  {
    path: '/educacaoinclusiva',
    name: 'EducacaoInclusiva',
    description: 'Educação Inclusiva',
    children: [
      ...pdiEstrutura,
      ...pdiRes4256,
      ...pdiAnamnese,
      ...pdiPendente,
      ...informacoesComplementares,
    ],
    goesToMenu: true,
  },
];
